import { createAsyncThunk } from "@reduxjs/toolkit";
import * as URL from "../../helpers/url_helper"
import { post, get, put, del } from "../../helpers/api_helper"


export const getCharacterStyle = createAsyncThunk(
  "getCharacterStyle",
  async ({ data, callBack }, Thunk) => {
    try {
      const response = await get(`${URL.GET_CHARACTER_STYLE}/${data}`);
      callBack && callBack(null, response);
      return response;
    } catch (error) {
      callBack && callBack(error);
      return Thunk.rejectWithValue(error);
    }
  }
);